<template>
  <div class="training-intents">
    <main-layout v-if="fromPage === 'inbox'">
      <template v-if="currentView == 'list'">
        <div style="position: relative; min-height: 100vh">
          <v-premium-plan-popup
            :showAll="false"
            marginTop="65"
            text="You can train bots to be more accurate and smart. Starting at 500 baht / month Upgrade now!"
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          ></v-premium-plan-popup>
          <v-container fluid>
            <v-layout>
              <v-flex shrink>
                <h1>
                  {{ $t('Default Conversation') }}
                  <a href="https://tinyurl.com/5aj2ksc4" target="blank"
                    ><i style="font-size: 18px; color: #ed1e79;" class="fas fa-question-circle"></i
                  ></a>
                </h1>
              </v-flex>
              <v-flex class="form-control text-xs-right">
                <input
                  type="text"
                  :placeholder="$t('Search')"
                  v-model="search"
                  @blur="onSearch"
                  @keyup.enter="onSearch"
                  style="max-width: 300px"
                />
              </v-flex>
            </v-layout>
            <template>
              <v-btn
                v-for="item in createFilterButtons()"
                :key="item.value"
                small
                depressed
                :outline="filterApp !== item.value"
                :color="filterApp === item.value ? 'primary' : 'grey'"
                @click="onFilterButtonClick(item.value)"
                class="ma-0 mr-1 mb-1"
              >
                <i :class="item.icon" class="mr-1"></i>
                {{ item.label }}
              </v-btn>
            </template>
            <v-layout wrap>
              <v-flex xs12 sm8 style="overflow-x: auto; white-space: nowrap">
                <!--:class="{'btn-primary': currentFilter == 'today' , 'btn-outline-gray' : currentFilter != 'today' }" -->
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'today'"
                  :outline="currentFilter != 'today'"
                  :color="currentFilter == 'today' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('today')"
                  >{{ $t('today') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'this_month'"
                  :outline="currentFilter != 'this_month'"
                  :color="currentFilter == 'this_month' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('this_month')"
                  >{{ $t('this month') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'this_year'"
                  :outline="currentFilter != 'this_year'"
                  :color="currentFilter == 'this_year' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('this_year')"
                  >{{ $t('this year') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'last_month'"
                  :outline="currentFilter != 'last_month'"
                  :color="currentFilter == 'last_month' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('last_month')"
                  >{{ $t('last 30 days') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'last_365_day'"
                  :outline="currentFilter != 'last_365_day'"
                  :color="currentFilter == 'last_365_day' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('last_365_day')"
                  >{{ $t('last 365 days') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'custom_date'"
                  :outline="currentFilter != 'custom_date'"
                  :color="currentFilter == 'custom_date' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('custom_date')"
                  >{{ $t('Custom Date') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 class="text-xs-left text-sm-right">
                <v-btn
                  fab
                  small
                  class="ma-1"
                  color="primary"
                  depressed
                  :outline="view != 'tag'"
                  @click="view = 'tag'"
                >
                  <span class="fas fa-th"></span>
                </v-btn>
                <v-btn
                  fab
                  small
                  class="ma-1"
                  color="primary"
                  depressed
                  :outline="view != 'list'"
                  @click="view = 'list'"
                >
                  <span class="fas fa-bars"></span>
                </v-btn>

                <v-btn
                  depressed
                  outline
                  color="primary"
                  :loading="loading"
                  :disabled="filterDefaultIntents.length == 0"
                  @click="onExportTraining"
                >
                  <i class="fas fa-file-export"></i>
                  &nbsp;{{ $t('export') }}&nbsp;
                  <v-premium-lock :inline="true"></v-premium-lock>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout v-if="currentFilter == 'custom_date'" style="margin-bottom: 0">
              <v-flex xs12 sm6 class="form-control">
                <span class="dashboard_datepicker">
                  {{ $t('from') }}:
                  <datepicker
                    calendar-class="color-black"
                    v-model="selectedDate.start"
                    style="margin-bottom: 10px"
                    @selected="onSelectedStartDate"
                    :disabledDates="disabledDates"
                    :min="new Date().toISOString().substr(0, 10)"
                  ></datepicker>
                </span>
              </v-flex>
              <v-flex xs12 sm6 class="form-control">
                <span class="dashboard_datepicker" style="margin-bottom: 10px">
                  {{ $t('to') }}:
                  <datepicker
                    calendar-class="color-black"
                    color="primary"
                    v-model="selectedDate.end"
                    style
                    @selected="onSelectedEndDate"
                    :disabledDates="disabledDates"
                  ></datepicker>
                </span>
              </v-flex>
              <v-flex xs12>
                <div class="text-xs-right">
                  <v-btn color="primary" @click="customloadTraining" small :loading="loading">
                    {{ $t('Search') }}
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>

          <div
            v-if="firstloading && $store.getters.getPackage === 'premium'"
            class="spinner text-xs-center"
            style="top:100px"
          >
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
          <template v-else>
            <template v-if="filterDefaultIntents.length > 0">
              <div style="padding: 0 15px">
                <div>
                  <div
                    class="px-2"
                    style="
                      background: #eee;

                      margin-bottom: 15px;
                      border-radius: 5px;
                    "
                  >
                    <v-layout style="margin-bottom: 0">
                      <v-flex>
                        <v-checkbox
                          class="mt-2"
                          color="primary"
                          v-model="allSelected"
                          :label="$t('Select All')"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex class=" text-xs-left text-sm-right">
                        <v-btn
                          href="javascript:void(0)"
                          outline
                          color="grey"
                          :loading="loading || loadingIntent"
                          class="primaryButton"
                          @click="
                            $store.getters.getPackage == 'premium' && !isCoachlab
                              ? ignoreAll()
                              : false
                          "
                          :disabled="selectedQuestionData.length == 0"
                          style="margin-bottom: 5px"
                          >{{ $t('Delete') }}</v-btn
                        >
                        <v-btn
                          depressed
                          color="primary"
                          class="primaryButton"
                          href="javascript:void(0)"
                          :loading="loading || loadingIntent"
                          @click="createNewAll"
                          :disabled="selectedQuestionData.length == 0"
                          style="margin-bottom: 5px"
                          >{{ $t('Create new') }}</v-btn
                        >
                        <v-btn
                          depressed
                          color="primary"
                          class="primaryButton"
                          href="javascript:void(0)"
                          :loading="loading || loadingIntent"
                          :disabled="selectedQuestionData.length == 0"
                          style="margin-bottom: 5px"
                          @click="
                            currentDefaultIntents = selectedQuestionData
                            showModal = true
                          "
                          >{{ $t('Add existing') }}</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </div>
                </div>
              </div>
            </template>

            <div class="container-fluid" style="padding: 0 15px">
              <div
                id="training_container"
                style="
                  max-height: 600px;
                  overflow-y: auto;
                  border: 1px solid #eee;
                  padding: 10px;
                  border-radius: 5px;
                "
              >
                <v-layout>
                  <v-flex>
                    <div class="text-xs-center">
                      <custom-paginate
                        v-model="pageNumber"
                        :hasNext="hasNext"
                        :hasPrev="hasPrev"
                        :pagelength="pageCount"
                        @onChangePage="onClickPageinate"
                        :loading="loading"
                      ></custom-paginate>
                    </div>
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on" class="caption mr-2"
                          >{{ $t('Total') }}<i class="ml-1 primary--text fas fa-question-circle"></i
                        ></span>
                      </template>
                      <span>{{ $t('Total untrained messages') }}</span>
                    </v-tooltip>
                    <template v-if="loading">
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </template>
                    <template v-else>
                      <template v-if="total === false">
                        <v-btn
                          fab
                          outline
                          small
                          color="primary"
                          :loading="loading"
                          v-if="$store.getters.getPackage != 'premium'"
                          v-tooltip.top="'Unlock to PREMIUM plan'"
                        >
                          <v-icon>lock</v-icon>
                        </v-btn>
                        <!-- <v-btn
                          v-else
                          outline
                          fab
                          small
                          color="primary"
                          :loading="loadCount"
                          @click="loadCountData"
                        >
                          <v-icon>refresh</v-icon>
                        </v-btn> -->
                      </template>
                      <template v-else>
                        <span
                          :style="
                            `font-size: 19px;color:${$vuetify.theme.primary};font-weight: 600`
                          "
                          >{{ total | numberFormat }}</span
                        >
                      </template>
                    </template>
                  </v-flex>
                </v-layout>
                <template v-if="filterDefaultIntents.length > 0">
                  <template v-if="view == 'tag'">
                    <ul class="tags">
                      <li
                        class="tag"
                        :class="{ active: intent.selected }"
                        style="
                                margin-right: 5px;
                                margin-bottom: 5px;
                                cursor: pointer;
                                text-align: left;
                              "
                        v-for="(intent, index) in filterDefaultIntents"
                        :key="'intent_' + intent.id + '_' + index"
                        :title="intent.questiondata"
                        @click="intent.selected = !intent.selected"
                      >
                        <span
                          :class="{
                            'fas fa-check-circle': intent.selected,
                            'far fa-circle': !intent.selected
                          }"
                        ></span>
                        <div
                          style="
                                  display: inline-block;
                                  vertical-align: middle;
                                  word-break: break-all;
                                "
                        >
                          {{ intent.questiondata }}
                        </div>
                        <template v-if="intent.count > 1">({{ intent.count }})</template>
                      </li>
                    </ul>
                  </template>

                  <template v-else>
                    <training-item
                      :loadingId="loadingId"
                      class="z-border-red"
                      style="padding: 10px 10px 0"
                      v-for="(intent, index) in filterDefaultIntents"
                      :key="'intent_' + intent.id + '_' + index"
                      v-model="filterDefaultIntents[index]"
                      @onAddExistingConversation="
                        currentDefaultIntents = []
                        currentDefaultIntents.push(intent.questiondata)
                        showModal = true
                      "
                      @onSaveTrainingConversation="saveTrainingIntent"
                      :excludedIntentName="excludedIntentName"
                      @onIgnore="onIgnore(intent.questiondata)"
                    ></training-item>
                  </template>
                </template>
                <template v-else>
                  <div class="text-xs-center" style="margin: 35px 0">
                    <img
                      src="/static/img/assets/setting/conversation.png"
                      alt
                      style="width: 230px"
                    />
                    <h3>{{ $t('No conversation') }}</h3>
                  </div>
                </template>
                <div class="text-xs-center">
                  <custom-paginate
                    v-model="pageNumber"
                    :hasNext="hasNext"
                    :hasPrev="hasPrev"
                    :pagelength="pageCount"
                    @onChangePage="onClickPageinate"
                    :loading="loading"
                  ></custom-paginate>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div style="height: 60px"></div>

        <v-dialog scrollable v-model="showModal" persistent max-width="1000">
          <v-card>
            <template v-if="showModal">
              <v-layout class="pa-2">
                <v-flex style="align-self: center;"
                  ><h2>{{ $t('Training') }}</h2></v-flex
                >
                <v-flex xs12 sm6 class="form-control text-xs-right" style="display: inherit;">
                  <div class="input-icons">
                    <i class="fa fa-search icon"></i>
                    <input
                      @keyup.enter="
                        pageNumberIntent = 1
                        getIntent()
                      "
                      type="text"
                      v-model="searchIntent"
                      class="form-control"
                      :placeholder="$t('Search Conversation Name')"
                      style="margin-bottom: 10px"
                    />
                    <v-btn
                      v-show="searchIntent.length > 0"
                      @click="clearSearch"
                      icon
                      class="icon-close"
                    >
                      <i class="fa fa-close"></i
                    ></v-btn>
                  </div>
                  <v-btn
                    @click="
                      pageNumberIntent = 1
                      getIntent()
                    "
                    color="primary"
                  >
                    {{ $t('Search') }}
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-divider />
              <v-card-text style="max-height: 600px; min-height: 213px;">
                <div class="mt-2 mb-2 text-xs-right">
                  <v-pagination
                    :total-visible="showsize"
                    v-model="pageNumberIntent"
                    @input="getIntent"
                    :length="pageCountIntent"
                  ></v-pagination>
                </div>
                <div class="spinner text-xs-center" v-if="loadingIntent">
                  <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
                </div>
                <div v-else>
                  <ul class="training-data" style="margin: 0; padding: 0" v-if="!loadingIntent">
                    <li
                      class="item z-border-red"
                      v-for="(intent, index) in filterIntents"
                      :key="'intent_' + index"
                      @click="addTrainingToConversation(intent)"
                    >
                      {{ intent.intentname }}
                    </li>
                  </ul>
                </div>
                <div class="mt-2 mb-2 text-xs-right" v-if="!loadingIntent">
                  <v-pagination
                    :total-visible="showsize"
                    v-model="pageNumberIntent"
                    @input="getIntent"
                    :length="pageCountIntent"
                  ></v-pagination>
                </div>
              </v-card-text>

              <v-divider />
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" depressed @click="showModal = false">{{
                  $t('cancel')
                }}</v-btn>
                <v-spacer />
              </v-card-actions>
            </template>
          </v-card>
        </v-dialog>
      </template>
      <template v-else-if="currentView == 'create_new'">
        <div class="container">
          <div class="row">
            <div class="col s12">
              <manage-intent
                :type="'add'"
                v-model="newIntent"
                @close="onClose"
                @saveIntent="onSaveIntent"
                :excludedIntentName="excludedIntentName"
              ></manage-intent>
            </div>
          </div>
        </div>
      </template>
    </main-layout>
    <template v-else>
      <template v-if="currentView == 'list'">
        <div style="position: relative; min-height: 100vh">
          <v-premium-plan-popup
            :showAll="false"
            marginTop="65"
            text="You can train bots to be more accurate and smart. Starting at 500 baht / month Upgrade now!"
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          ></v-premium-plan-popup>
          <v-container fluid>
            <v-layout>
              <v-flex shrink>
                <h1>
                  {{ $t('Default Conversation') }}
                  <a href="https://tinyurl.com/5aj2ksc4" target="blank"
                    ><i style="font-size: 18px; color: #ed1e79;" class="fas fa-question-circle"></i
                  ></a>
                </h1>
              </v-flex>
              <v-flex class="form-control text-xs-right">
                <input
                  type="text"
                  :placeholder="$t('Search')"
                  v-model="search"
                  @blur="onSearch"
                  @keyup.enter="onSearch"
                  style="max-width: 300px"
                />
              </v-flex>
            </v-layout>
            <template>
              <v-btn
                v-if="status_facebook"
                small
                depressed
                :outline="filterApp != 'facebook'"
                :color="filterApp == 'facebook' ? 'primary' : 'grey'"
                @click="
                  filterApp = 'facebook'
                  onSelectedDate()
                "
                class="ma-0 mr-1 mb-1"
              >
                <i class="fab fa-facebook-square mr-1"></i>
                {{ $t('Facebook') }}
              </v-btn>
              <v-btn
                v-if="status_line"
                small
                depressed
                :outline="filterApp != 'line'"
                :color="filterApp == 'line' ? 'primary' : 'grey'"
                @click="
                  filterApp = 'line'
                  onSelectedDate()
                "
                class="ma-0 mr-1 mb-1"
              >
                <i class="fab fa-line mr-1"></i>
                {{ $t('Line') }}
              </v-btn>
              <v-btn
                v-if="status_ig"
                small
                depressed
                :outline="filterApp != 'instagram'"
                :color="filterApp == 'instagram' ? 'primary' : 'grey'"
                @click="
                  filterApp = 'instagram'
                  onSelectedDate()
                "
                class="ma-0 mr-1 mb-1"
              >
                <i class="fab fa-instagram mr-1"></i>
                {{ $t('Instagram') }}</v-btn
              >
              <v-btn
                v-if="status_google"
                small
                depressed
                :outline="filterApp != 'google'"
                :color="filterApp == 'google' ? 'primary' : 'grey'"
                @click="
                  filterApp = 'google'
                  onSelectedDate()
                "
                class="ma-0 mr-1 mb-1"
              >
                <i class="fab fa-google mr-1"></i>
                {{ $t('Google') }}</v-btn
              >
              <v-btn
                v-if="status_whatsapp"
                small
                depressed
                :outline="filterApp != 'whatsapp'"
                :color="filterApp == 'whatsapp' ? 'primary' : 'grey'"
                @click="
                  filterApp = 'whatsapp'
                  onSelectedDate()
                "
                class="ma-0 mr-1 mb-1"
              >
                <i class="fab fa-whatsapp mr-1"></i>
                {{ $t('WhatsApp') }}</v-btn
              >
            </template>
            <v-layout wrap>
              <v-flex xs12 sm8 style="overflow-x: auto; white-space: nowrap">
                <!--:class="{'btn-primary': currentFilter == 'today' , 'btn-outline-gray' : currentFilter != 'today' }" -->
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'today'"
                  :outline="currentFilter != 'today'"
                  :color="currentFilter == 'today' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('today')"
                  >{{ $t('today') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'this_month'"
                  :outline="currentFilter != 'this_month'"
                  :color="currentFilter == 'this_month' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('this_month')"
                  >{{ $t('this month') }}</v-btn
                >
                <!-- <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'this_year'"
                  :outline="currentFilter != 'this_year'"
                  :color="currentFilter == 'this_year' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('this_year')"
                  >{{ $t('this year') }}</v-btn
                > -->
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'last_month'"
                  :outline="currentFilter != 'last_month'"
                  :color="currentFilter == 'last_month' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('last_month')"
                  >{{ $t('last 30 days') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'last_90_day'"
                  :outline="currentFilter != 'last_90_day'"
                  :color="currentFilter == 'last_90_day' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('last_90_day')"
                  >{{ $t('last 90 days') }}</v-btn
                >
                <v-btn
                  class="primaryButton"
                  href="javascript:void(0)"
                  :depressed="currentFilter == 'custom_date'"
                  :outline="currentFilter != 'custom_date'"
                  :color="currentFilter == 'custom_date' ? 'primary' : `grey`"
                  style="margin-bottom: 5px"
                  @click="changeDate('custom_date')"
                  >{{ $t('Custom Date') }}</v-btn
                >
              </v-flex>
              <v-flex xs12 sm4 class="text-xs-left text-sm-right">
                <v-btn
                  fab
                  small
                  class="ma-1"
                  color="primary"
                  depressed
                  :outline="view != 'tag'"
                  @click="view = 'tag'"
                >
                  <span class="fas fa-th"></span>
                </v-btn>
                <v-btn
                  fab
                  small
                  class="ma-1"
                  color="primary"
                  depressed
                  :outline="view != 'list'"
                  @click="view = 'list'"
                >
                  <span class="fas fa-bars"></span>
                </v-btn>

                <v-btn
                  depressed
                  outline
                  color="primary"
                  :loading="loading"
                  :disabled="filterDefaultIntents.length == 0"
                  @click="onExportTraining"
                >
                  <i class="fas fa-file-export"></i>
                  &nbsp;{{ $t('export') }}&nbsp;
                  <v-premium-lock :inline="true"></v-premium-lock>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout v-if="currentFilter == 'custom_date'" style="margin-bottom: 0">
              <v-flex xs12 sm6 class="form-control">
                <span class="dashboard_datepicker">
                  {{ $t('from') }}:
                  <datepicker
                    calendar-class="color-black"
                    v-model="selectedDate.start"
                    style="margin-bottom: 10px"
                    @selected="onSelectedStartDate"
                    :disabledDates="disabledDates"
                    :min="new Date().toISOString().substr(0, 10)"
                  ></datepicker>
                </span>
              </v-flex>
              <v-flex xs12 sm6 class="form-control">
                <span class="dashboard_datepicker" style="margin-bottom: 10px">
                  {{ $t('to') }}:
                  <datepicker
                    calendar-class="color-black"
                    color="primary"
                    v-model="selectedDate.end"
                    style
                    @selected="onSelectedEndDate"
                    :disabledDates="disabledDates"
                  ></datepicker>
                </span>
              </v-flex>
              <v-flex xs12>
                <div class="text-xs-right">
                  <v-btn color="primary" @click="customloadTraining" small :loading="loading">
                    {{ $t('Search') }}
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>

          <div
            v-if="firstloading && $store.getters.getPackage === 'premium'"
            class="spinner text-xs-center"
            style="top:100px"
          >
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
          <template v-else>
            <template v-if="filterDefaultIntents.length > 0">
              <div style="padding: 0 15px">
                <div>
                  <div
                    class="px-2"
                    style="
                      background: #eee;

                      margin-bottom: 15px;
                      border-radius: 5px;
                    "
                  >
                    <v-layout style="margin-bottom: 0">
                      <v-flex>
                        <v-checkbox
                          class="mt-2"
                          color="primary"
                          v-model="allSelected"
                          :label="$t('Select All')"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex class=" text-xs-left text-sm-right">
                        <v-btn
                          href="javascript:void(0)"
                          outline
                          color="grey"
                          :loading="loading || loadingIntent"
                          class="primaryButton"
                          @click="
                            $store.getters.getPackage == 'premium' && !isCoachlab
                              ? ignoreAll()
                              : false
                          "
                          :disabled="selectedQuestionData.length == 0"
                          style="margin-bottom: 5px"
                          >{{ $t('Delete') }}</v-btn
                        >
                        <v-btn
                          depressed
                          color="primary"
                          class="primaryButton"
                          href="javascript:void(0)"
                          :loading="loading || loadingIntent"
                          @click="createNewAll"
                          :disabled="selectedQuestionData.length == 0"
                          style="margin-bottom: 5px"
                          >{{ $t('Create new') }}</v-btn
                        >
                        <v-btn
                          depressed
                          color="primary"
                          class="primaryButton"
                          href="javascript:void(0)"
                          :loading="loading || loadingIntent"
                          :disabled="selectedQuestionData.length == 0"
                          style="margin-bottom: 5px"
                          @click="
                            currentDefaultIntents = selectedQuestionData
                            showModal = true
                          "
                          >{{ $t('Add existing') }}</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </div>
                </div>
              </div>
            </template>

            <div class="container-fluid" style="padding: 0 15px">
              <div
                id="training_container"
                style="
                  max-height: 600px;
                  overflow-y: auto;
                  border: 1px solid #eee;
                  padding: 10px;
                  border-radius: 5px;
                "
              >
                <v-layout>
                  <v-flex>
                    <div class="text-xs-center">
                      <custom-paginate
                        v-model="pageNumber"
                        :hasNext="hasNext"
                        :hasPrev="hasPrev"
                        :pagelength="pageCount"
                        @onChangePage="onClickPageinate"
                        :loading="loading"
                      ></custom-paginate>
                    </div>
                  </v-flex>
                  <v-flex class="text-xs-right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on" class="caption mr-2"
                          >{{ $t('Total') }}<i class="ml-1 primary--text fas fa-question-circle"></i
                        ></span>
                      </template>
                      <span>{{ $t('Total untrained messages') }}</span>
                    </v-tooltip>
                    <template v-if="loading">
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </template>
                    <template v-else>
                      <template v-if="total === false">
                        <v-btn
                          fab
                          outline
                          small
                          color="primary"
                          :loading="loading"
                          v-if="$store.getters.getPackage != 'premium'"
                          v-tooltip.top="'Unlock to PREMIUM plan'"
                        >
                          <v-icon>lock</v-icon>
                        </v-btn>
                        <!-- <v-btn
                          v-else
                          outline
                          fab
                          small
                          color="primary"
                          :loading="loadCount"
                          @click="loadCountData"
                        >
                          <v-icon>refresh</v-icon>
                        </v-btn> -->
                      </template>
                      <template v-else>
                        <span
                          :style="
                            `font-size: 19px;color:${$vuetify.theme.primary};font-weight: 600`
                          "
                          >{{ total | numberFormat }}</span
                        >
                      </template>
                    </template>
                  </v-flex>
                </v-layout>
                <template v-if="filterDefaultIntents.length > 0">
                  <template v-if="view == 'tag'">
                    <ul class="tags">
                      <li
                        class="tag"
                        :class="{ active: intent.selected }"
                        style="
                                margin-right: 5px;
                                margin-bottom: 5px;
                                cursor: pointer;
                                text-align: left;
                              "
                        v-for="(intent, index) in filterDefaultIntents"
                        :key="'intent_' + intent.id + '_' + index"
                        :title="intent.questiondata"
                        @click="intent.selected = !intent.selected"
                      >
                        <span
                          :class="{
                            'fas fa-check-circle': intent.selected,
                            'far fa-circle': !intent.selected
                          }"
                        ></span>
                        <div
                          style="
                                  display: inline-block;
                                  vertical-align: middle;
                                  word-break: break-all;
                                "
                        >
                          {{ intent.questiondata }}
                        </div>
                        <template v-if="intent.count > 1">({{ intent.count }})</template>
                      </li>
                    </ul>
                  </template>

                  <template v-else>
                    <training-item
                      :loadingId="loadingId"
                      class="z-border-red"
                      style="padding: 10px 10px 0"
                      v-for="(intent, index) in filterDefaultIntents"
                      :key="'intent_' + intent.id + '_' + index"
                      v-model="filterDefaultIntents[index]"
                      @onAddExistingConversation="
                        currentDefaultIntents = []
                        currentDefaultIntents.push(intent.questiondata)
                        showModal = true
                      "
                      @onSaveTrainingConversation="saveTrainingIntent"
                      :excludedIntentName="excludedIntentName"
                      @onIgnore="onIgnore(intent.questiondata)"
                    ></training-item>
                  </template>
                </template>
                <template v-else>
                  <div class="text-xs-center" style="margin: 35px 0">
                    <img
                      src="/static/img/assets/setting/conversation.png"
                      alt
                      style="width: 230px"
                    />
                    <h3>{{ $t('No conversation') }}</h3>
                  </div>
                </template>
                <div class="text-xs-center">
                  <custom-paginate
                    v-model="pageNumber"
                    :hasNext="hasNext"
                    :hasPrev="hasPrev"
                    :pagelength="pageCount"
                    @onChangePage="onClickPageinate"
                    :loading="loading"
                  ></custom-paginate>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div style="height: 60px"></div>

        <v-dialog scrollable v-model="showModal" persistent max-width="1000">
          <v-card>
            <template v-if="showModal">
              <v-layout class="pa-2">
                <v-flex style="align-self: center;"
                  ><h2>{{ $t('Training') }}</h2></v-flex
                >
                <v-flex xs12 sm6 class="form-control text-xs-right" style="display: inherit;">
                  <div class="input-icons">
                    <i class="fa fa-search icon"></i>
                    <input
                      @keyup.enter="
                        pageNumberIntent = 1
                        getIntent()
                      "
                      type="text"
                      v-model="searchIntent"
                      class="form-control"
                      :placeholder="$t('Search Conversation Name')"
                      style="margin-bottom: 10px"
                    />
                    <v-btn
                      v-show="searchIntent.length > 0"
                      @click="clearSearch"
                      icon
                      class="icon-close"
                    >
                      <i class="fa fa-close"></i
                    ></v-btn>
                  </div>
                  <v-btn
                    @click="
                      pageNumberIntent = 1
                      getIntent()
                    "
                    color="primary"
                  >
                    {{ $t('Search') }}
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-divider />
              <v-card-text style="max-height: 600px; min-height: 213px;">
                <div class="mt-2 mb-2 text-xs-right">
                  <v-pagination
                    :total-visible="showsize"
                    v-model="pageNumberIntent"
                    @input="getIntent"
                    :length="pageCountIntent"
                  ></v-pagination>
                </div>
                <div class="spinner text-xs-center" v-if="loadingIntent">
                  <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
                </div>
                <div v-else>
                  <ul class="training-data" style="margin: 0; padding: 0;">
                    <li
                      class="item z-border-red"
                      v-for="(intent, index) in filterIntents"
                      :key="'intent_' + index"
                      @click="addTrainingToConversation(intent)"
                    >
                      {{ intent.intentname }}
                    </li>
                  </ul>
                </div>
                <div class="mt-2 mb-2 text-xs-right" v-if="!loadingIntent">
                  <v-pagination
                    :total-visible="showsize"
                    v-model="pageNumberIntent"
                    @input="getIntent"
                    :length="pageCountIntent"
                  ></v-pagination>
                </div>
              </v-card-text>

              <v-divider />
              <v-card-actions>
                <v-spacer />
                <v-btn color="primary" depressed @click="showModal = false">{{
                  $t('cancel')
                }}</v-btn>
                <v-spacer />
              </v-card-actions>
            </template>
          </v-card>
        </v-dialog>
      </template>
      <template v-else-if="currentView == 'create_new'">
        <div class="container">
          <div class="row">
            <div class="col s12">
              <manage-intent
                :type="'add'"
                v-model="newIntent"
                @close="onClose"
                @saveIntent="onSaveIntent"
                :excludedIntentName="excludedIntentName"
              ></manage-intent>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ModalDialog from '@/components/elements/ModalDialog'
import TrainingItem from './TrainingItem'
import api from '@/api'
// import { clearInterval } from "timers";

import datepicker from 'vuejs-datepicker'
import dayjs from 'dayjs'
import ManageIntent from './intent-manage'
import CustomPaginate from '@/components/elements/CustomPaginate'
import { cloneDeep } from 'lodash'

import XLSX from 'xlsx'
export default {
  data: function() {
    return {
      pageNumberIntent: 1,
      isShow: false,
      showsize: 15,
      tmp_intent: [],
      alltrainingdata: [],
      pageNumber: 1,
      size: 50,
      loadingId: '',
      currentView: 'list',
      training_intents: [],
      loading: false,
      loadingIntent: true,
      firstloading: true,
      intents: [],
      search: '',
      searchIntent: '',
      showModal: false,
      currentDefaultIntents: [],
      allSelected: false,
      selectedDate: {
        start: dayjs()
          .startOf('month')
          .toDate(),
        end: dayjs().toDate()
      },
      currentFilter: 'this_month',
      ignoreInterval: undefined,
      ignoreCount: 0,
      view: 'tag',
      newIntent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '[[]]',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        userstatus: null,
        usertags: null,
        linenoti_status: false,
        linenoti_spec_ids: null,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true
      },
      training_process_count: 0,
      loadingTraining: null,
      trainingCount: 0,
      offset: 0,
      total: 0,
      hasNext: false,
      hasPrev: false,
      loadCount: false,
      counttype: 'onetime',
      fromPage: null,
      filterApp: 'facebook',
      disabledDates: {
        to: dayjs()
          .subtract(1, 'year')
          .toDate(), // Disable all dates up to specific date
        from: dayjs().toDate() // Disable all dates after specific date
      },
      status_facebook: false,
      status_line: false,
      status_ig: false,
      status_whatsapp: false,
      status_google: false
    }
  },
  components: {
    ModalDialog,
    TrainingItem,
    datepicker,
    ManageIntent,
    CustomPaginate
  },
  mounted: async function() {
    var vm = this
    if (vm.$store.getters.getPackage != 'premium' || vm.isCoachlab) {
      return false
    }
    if (vm.$route.query.from) {
      vm.fromPage = vm.$route.query.from
    }
    if (vm.$route.query.datefrom) {
      vm.selectedDate.start = vm.$route.query.datefrom
    }
    if (vm.$route.query.dateto) {
      vm.selectedDate.end = vm.$route.query.dateto
    }
    if (vm.$route.query.datefrom || vm.$route.query.dateto) {
      vm.currentFilter = 'custom_date'
    }

    const packages = vm.selectedBot.packages
    if (packages.includes('facebook')) {
      vm.status_facebook = true
    }
    if (packages.includes('line')) {
      vm.status_line = true
    }
    if (packages.includes('instagram')) {
      vm.status_ig = true
    }
    if (packages.includes('whatsapp')) {
      vm.status_whatsapp = true
    }
    if (packages.includes('google')) {
      vm.status_google = true
    }

    vm.firstloading = true
    try {
      await vm.loadTraining({ limit: vm.size, offset: vm.offset })
      // var response = await vm.getTrainingConversation({ limit: vm.size, offset: vm.offset })
    } catch (error) {}
    vm.firstloading = false
    vm.loadingIntent = true

    try {
      await vm.getIntent()
    } catch (error) {}
    // vm.loadCountData()
    vm.loadingIntent = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),

    default_intent() {
      var default_intent = this.$store.getters.getIntents('default')
      default_intent = default_intent.length > 0 ? default_intent[0] : false

      if (default_intent == false) {
        default_intent = {
          ...cloneDeep(this.intentTemplate()),
          intentname: '{default}',
          a_val: '[[]]',
          ableToDelete: false,
          isShow: false
        }
      } else {
      }
      return default_intent
    },
    pageCount: function() {
      let l = this.total
      let s = this.size
      return Math.ceil(l / s) === 0 ? 1 : Math.ceil(l / s)
    },
    excludedIntentName: function() {
      var result = []
      var vm = this
      result = vm.intents.map(intent => {
        return intent && intent.intentname ? intent.intentname : null
      })

      return result.join(',')
    },
    filterDefaultIntents: function() {
      var vm = this
      var sorted = vm.training_intents.sort(function(a, b) {
        var nameA = a.questiondata.toUpperCase()
        var nameB = b.questiondata.toUpperCase()
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })

      // var training = sorted.filter(intent => {
      //   var isFound = false
      //   if (intent.questiondata != null && intent.questiondata != '') {
      //     isFound =
      //       intent.questiondata.toLowerCase().includes(vm.search.toLowerCase()) &&
      //       intent.training != true
      //   }
      //   return isFound
      // })

      // vm.trainingCount = training.length
      return sorted
      // const start = (this.pageNumber - 1) * this.size
      // const end = start + this.size
      // return training.slice(start, end)
    },
    filterIntents: function() {
      var vm = this
      vm.intents.sort(function(a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })

      return vm.intents
    },
    selectedQuestionData: function() {
      var questions = []
      var vm = this
      if (vm.filterDefaultIntents) {
        vm.filterDefaultIntents.map(function(el) {
          if (el.selected) {
            questions.push(el.questiondata)
          }
        })
      }
      return questions
    }
  },
  methods: {
    createFilterButtons() {
      const vm = this
      return [
        {
          label: vm.$t('Facebook'),
          value: 'facebook',
          icon: 'fab fa-facebook-square'
        },
        {
          label: vm.$t('Line'),
          value: 'line',
          icon: 'fab fa-line'
        },
        {
          label: vm.$t('Instagram'),
          value: 'instagram',
          icon: 'fab fa-instagram'
        },
        {
          label: vm.$t('Google'),
          value: 'google',
          icon: 'fab fa-google'
        },
        {
          label: vm.$t('whatsapp'),
          value: 'whatsapp',
          icon: 'fab fa-whatsapp'
        }
      ]
    },
    onFilterButtonClick(item) {
      const vm = this
      vm.filterApp = item
      vm.onSelectedDate()
    },
    async onSearch() {
      this.offset = 0
      this.total = 0
      this.pageNumber = 1
      await this.loadTraining({ limit: this.size, offset: this.offset })
    },
    getTotalIntents() {},
    // async loadCountData() {
    //   this.loadCount = true
    //   if (this.counttype == 'onetime') {
    //     try {
    //       var { total } = await this.getTrainingConversation()
    //       this.total = total
    //     } catch (error) {
    //       console.log(error)
    //       this.total = false
    //       this.counttype = 'recursive'
    //     }
    //   } else {
    //     var { total } = await this.recursiveLoadIntents(3000, 0)

    //     this.total = total
    //   }

    //   this.loadCount = false
    // },
    // async recursiveLoadIntents(limit, offset) {
    //   var { total, isnext } = await this.getTrainingConversation({ limit, offset })

    //   if (isnext) {
    //     var next = await this.recursiveLoadIntents({ limit, offset: offset + limit })

    //     return {
    //       users: null,
    //       isnext: isnext,
    //       total: parseInt(total) + (next.total ? parseInt(next.total) : 0)
    //     }
    //   } else {
    //     return { users: null, isnext: false, total: total }
    //   }
    // },
    async onClickPageinate({ currentpage, newpage, onchange }) {
      this.pageNumber = newpage
      this.firstloading = true
      if (this.pageNumber == 1) {
        this.offset = 0
      } else {
        this.offset = (this.pageNumber - 1) * this.size
      }
      try {
        var { training, isnext, total } = await this.getTrainingConversation({
          limit: this.size,
          offset: this.offset
        })
        this.training_intents = training
        if (newpage - 1 != 0) this.hasPrev = true
        this.hasNext = isnext
        this.total = total
        // if (response.training.length == 0) {
        //   this.total = this.pageNumber * this.size
        // } else {
        //   this.total = response.total
        // }
      } catch (error) {
        console.log(error)
      }
      this.firstloading = false
      this.$nextTick(() => {
        $('html, body').animate({
          scrollTop: 0
        })
        $('#training_container').animate({
          scrollTop: 0
        })
      })
    },
    onSaveIntent: async function(payload) {
      var vm = this
      vm.loading = true
      vm.currentView = 'list'
      let trainingPromise = []
      vm.$store.commit('SET_INTENT', payload)
      vm.$forceUpdate()
      if (vm.selectedQuestionData) {
        vm.loading = true
        vm.training_process_count = vm.selectedQuestionData.length
        var questionDataIntents = vm.training_intents.filter(intent => {
          return intent.selected
        })
        var datapayload = {
          intentname: payload.intentname,
          chatloglist: [].concat.apply(
            [],
            questionDataIntents.map(el => el.idlist)
          ) //merge all array
        }

        await vm.saveTrainingIntent(datapayload)

        // vm.currentDefaultIntents = []
        vm.loading = false
      }
    },
    onClose: function() {
      this.currentView = 'list'
    },
    onSelectedStartDate: async function(value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (dayjs(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value
      }
      this.selectedDate.start = value
    },
    createNewAll: function() {
      var vm = this

      vm.newIntent = {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: vm.selectedQuestionData.join(','),
        a_val: '[[]]',
        context_in: '',
        context_out: '',
        postidlist: '',
        userstatus: '',
        usertags: '',
        isShow: false,
        userstatus: null,
        usertags: null,
        linenoti_status: false,
        linenoti_spec_ids: null,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true
      }
      vm.currentView = 'create_new'
    },
    onSelectedEndDate: async function(value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (dayjs(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value
      }
      this.selectedDate.end = value
    },
    customloadTraining() {
      const vm = this
      vm.loadTraining({ limit: this.size, offset: this.offset })
    },
    async loadTraining({ limit, offset }) {
      this.loading = true
      try {
        this.offset = 0
        var { total, isnext, training } = await this.getTrainingConversation({
          limit: limit,
          offset: offset
        })
        this.training_intents = training
        // this.total = 0
        this.total = total
        this.hasNext = isnext
        this.hasPrev = false
        this.pageNumber = 1
        // await this.loadCountData()
      } catch (error) {}
      this.loading = false
    },
    onSelectedDate: async function(value) {
      var vm = this
      vm.loading = true
      try {
        vm.offset = 0
        var { training, total, isnext } = await vm.getTrainingConversation({
          limit: vm.size,
          offset: vm.offset
        })
        vm.training_intents = training
        this.total = total
        this.hasNext = isnext
        this.hasPrev = false
        this.pageNumber = 1
        // this.loadCountData()
      } catch (error) {}
      vm.loading = false
    },
    changeDate: function(value) {
      var vm = this
      vm.currentFilter = value
      switch (value) {
        case 'today':
          vm.selectedDate.start = dayjs().toDate()
          vm.selectedDate.end = dayjs().toDate()
          vm.onSelectedDate()
          break

        case 'last_month':
          vm.selectedDate.start = dayjs()
            .subtract(1, 'months')
            .toDate()
          vm.selectedDate.end = dayjs().toDate()
          vm.onSelectedDate()
          break

        case 'this_month':
          vm.selectedDate.start = dayjs()
            .startOf('month')
            .toDate()
          vm.selectedDate.end = dayjs()
            .endOf('month')
            .toDate()
          vm.onSelectedDate()
          break

        case 'this_year':
          vm.selectedDate.start = dayjs()
            .startOf('year')
            .toDate()
          vm.selectedDate.end = dayjs()
            .endOf('year')
            .toDate()
          vm.onSelectedDate()
          break

        case 'last_90_day':
          vm.selectedDate.start = dayjs()
            .subtract(90, 'days')
            .toDate()
          vm.selectedDate.end = dayjs().toDate()
          vm.onSelectedDate()
          break

        case 'last_365_day':
          vm.selectedDate.start = dayjs()
            .subtract(365, 'days')
            .toDate()
          vm.selectedDate.end = dayjs().toDate()
          vm.onSelectedDate()
          break
        case 'custom_date':
          vm.selectedDate = {
            start: dayjs()
              .startOf('month')
              .toDate(),
            end: dayjs().toDate()
          }
          break
      }
    },
    getTrainingConversation: function(options) {
      const vm = this
      return new Promise((resolve, reject) => {
        var data = {
          app: vm.filterApp,
          pageid: vm.selectedBot.pageid,
          intentname: '{default}',
          datefrom: dayjs(vm.selectedDate.start).format('YYYY-MM-DD'),
          dateto: dayjs(vm.selectedDate.end).format('YYYY-MM-DD'),
          training: 'false'
        }
        if (vm.search && vm.search.trim() != '') {
          data.messagedata = vm.search.trim()
        }
        if (options) {
          data = { ...data, limit: options.limit || null, offset: options.offset || null }
        }
        // console.time('load training')
        api.getTraningConversation(data, function(error, response) {
          if (error && response && response.responsecode && response.responsecode === 422) {
            // vm.$swal.fire({
            //   title: vm.$t('Unsuccessful'),
            //   text: response && response.reason ? response.reason.replace(/_/g, ' ') : '',
            //   type: 'error',
            //   confirmButtonText: vm.$t('Confirm'),
            //   reverseButtons: true
            // })
            vm.training_intents = []
            vm.loading = false
            return { training: [], total: 0, isnext: false }
          } else if (error) {
            reject(error)
          }
          // console.timeEnd('load training')
          var training_intents = []
          response.data = response.data.filter(el => {
            return !el.questiondata.includes(';base64,')
          })
          vm.total = response.total_count
            ? Number(response.total_count)
            : 0 || response.total
            ? Number(response.total)
            : 0 || 0
          training_intents = response.data
            .map(el => {
              return {
                ...el,
                selected: false
              }
            })
            .reduce((prev, curr) => {
              let intentIndex = prev.findIndex(el => {
                return el.id != curr.id && curr.questiondata == el.questiondata
              })
              if (intentIndex != -1) {
                prev[intentIndex].count += 1
                prev[intentIndex].idlist.push(curr.id)
              } else {
                prev.push({
                  ...curr,
                  count: 1,
                  idlist: [curr.id]
                })
              }
              return prev
            }, [])

          resolve({
            training: training_intents,
            total: response.total ? response.total : 0,
            isnext: response.is_next
          })
        })
      })
    },
    clearSearch() {
      const vm = this
      vm.searchIntent = ''
      vm.getIntent()
    },
    getIntent: function() {
      let vm = this
      vm.loadingIntent = true
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid,
        limit: vm.showsize,
        offset: (vm.pageNumberIntent - 1) * vm.showsize,
        page_intent: 'conversation',
        search_intent: vm.searchIntent || '',
        sort_by: 'intentname',
        sort_type: 'asc'
      }
      vm.intents = []
      return new Promise((resolve, reject) => {
        // console.time('load intent')
        api.getIntent(data, function(error, response) {
          if (error) {
            reject(error)
          }
          // console.timeEnd('load intent')
          if (response.data) {
            vm.pageCountIntent = Math.ceil(response.total_count / vm.showsize)
            var isFoundDefault = false
            var intents = response.data.map(val => {
              var intent = val
              intent.isShow = false
              intent.ableToDelete = true
              if (intent.intentname == '{default}') {
                intent.ableToDelete = false
                isFoundDefault = true
                vm.default_intent = intent
              } else {
                return intent
              }
            })
            vm.intents = intents
          }
          vm.loadingIntent = false
          resolve()
        })
      })
    },
    addTrainingToConversation: async function(intent) {
      let vm = this
      if (
        !vm.currentDefaultIntents ||
        (vm.currentDefaultIntents && vm.currentDefaultIntents.length == 0)
      ) {
        return false
      }

      let data = {
        q_val: vm.currentDefaultIntents.join(','),
        pageid: vm.selectedBot.pageid
      }

      var result = await vm.$swal.fire({
        title: vm.$t('Do you want to add {question} to {intent}?', {
          question: (
            vm.currentDefaultIntents[0] + (vm.currentDefaultIntents.length > 1 ? '...' : '')
          ).replace(/\<|\>/g, ''),
          intent: intent.intentname.replace(/\<|\>/g, '')
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.loading = true
        vm.showModal = false
        data['id'] = intent.id
        var request = {
          data: data,
          params: {
            id: data['id']
          }
        }
        let trainingPromise = []
        try {
          let response = await this.putQvalIntents(request)
          if (vm.currentDefaultIntents) {
            // vm.loadingId = vm.currentDefaultIntents[0]
            // vm.training_process_count = vm.currentDefaultIntents.length
            var questionDataIntents = vm.training_intents.filter(intent => {
              return intent.selected
            })
            var datapayload = {
              intentname: intent.intentname,
              chatloglist: [].concat.apply(
                [],
                questionDataIntents.map(el => el.idlist)
              ) //merge all array
            }

            await vm.saveTrainingIntent(datapayload)

            vm.currentDefaultIntents = []
            vm.loading = false
            // vm.getIntent(function() {
            //   vm.getTrainingConversation().then(
            //     function() {
            //       vm.loading = false
            //     },
            //     function(err) {
            //       vm.loading = false
            //     }
            //   )
            // })
          }

          // vm.loadingTraining = setInterval(function() {
          //   if (vm.training_process_count === 0) {
          //     if (vm.loadingTraining) {
          //       clearInterval(vm.loadingTraining)
          //       vm.currentDefaultIntents = []
          //       vm.getIntent(function() {
          //         vm.getTrainingConversation().then(
          //           function() {
          //             vm.loading = false
          //           },
          //           function(err) {
          //             vm.loading = false
          //           }
          //         )
          //       })
          //     }
          //   }
          // }, 1000)
        } catch (error) {
          console.error(error)
          vm.loading = false
        }
      }
    },
    putQvalIntents(request) {
      return new Promise((resolve, reject) => {
        api.putQvalIntents(request, function(error, response) {
          if (error) {
            reject(error)
          }

          resolve()
        })
      })
    },
    putupdateTrainingConversation: function(data, callback) {
      var vm = this
      api.putupdateTrainingConversation(data, function(error, response) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        if (vm.training_intents.length <= 0) {
          callback(null)
          return false
        }
        $.each(vm.training_intents, function(index, intent) {
          if (intent.questiondata == data.questiondata) {
            callback(index)
            return false
          }
        })
      })
    },
    saveTrainingIntent: function(payload) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.selectedBot.pageid,
          questiondata: payload.questiondata,
          chatloglist: payload.chatloglist,
          newintent: payload.intentname
        }
        api.putupdateTrainingConversation(data, function(err, response) {
          if (response && response.responsecode == 200) {
            var traininglist = []
            // traininglist = response.data.map(el => {
            //   return el.questiondata
            // })
            vm.training_intents = vm.training_intents.filter(el => {
              return !payload.chatloglist.includes(el.id)
            })

            resolve(response)
          }
        })
      })
    },
    ignoreAll: async function() {
      var vm = this
      var result = await vm.$swal.fire({
        title: vm.$t('Do you want to delete selected?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        vm.loading = true

        var intentList = []

        var ignoreIntents = vm.training_intents.filter(intent => {
          return intent.selected
        })
        // ignoreIntents.forEach((intent) => {
        //   intentList.push(intent.id)
        // })

        vm.ignoreTrainingIntent(
          [].concat.apply(
            [],
            ignoreIntents.map(el => el.idlist)
          )
        ) //merge all array)
        this.total = this.total - 1
        // await Promise.all(promiseIgnoreTrainingIntent)
        var questiondata = ignoreIntents.map(intent => {
          return intent.questiondata
        })

        var filterTraining = vm.training_intents.filter(intent => {
          return !questiondata.includes(intent.questiondata)
        })

        vm.training_intents = filterTraining

        vm.loading = false

        // vm.ignoreInterval = setInterval(() => {
        //   if (vm.ignoreCount == 0) {
        //     clearInterval(vm.ignoreInterval)

        //   }
        // }, 1000)
      }
    },
    onIgnore: async function(id) {
      var vm = this
      var result = await vm.$swal.fire({
        title: vm.$t('Do you want to delete selected?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.loading = true
        vm.loadingId = id
        try {
          await vm.ignoreTrainingIntent(id)
          var filterTraining = vm.training_intents.filter(intent => {
            return intent.questiondata != id
          })
          vm.training_intents = filterTraining

          // await vm.getIntent()
          // var response = await vm.getTrainingConversation({ limit: vm.size, offset: vm.offset })
          // vm.training_intents = response.training
          // vm.total = response.total
        } catch (error) {}
        vm.loading = false
      }
    },
    ignoreTrainingIntent: function(chatloglist) {
      var vm = this
      return new Promise((resolve, reject) => {
        // vm.$store.dispatch("loading");
        var data = {
          pageid: vm.selectedBot.pageid,
          chatloglist: chatloglist,
          newintent: ''
        }
        vm.putupdateTrainingConversation(data, function(index) {
          resolve()
        })
      })
    },
    selectAll: function() {
      var vm = this
      vm.intentId = []
      $.each(vm.filterDefaultIntents, function(index, intent) {
        $.each(vm.training_intents, function(dindex, dintent) {
          if (intent.id == dintent.id) {
            vm.training_intents[dindex].selected = vm.allSelected
            return false
          }
        })
      })
    },
    select: function() {
      this.allSelected = false
    },
    onExportTraining: async function() {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }
      vm.loading = true
      var response = await vm.getTrainingConversation({ limit: vm.total, offset: 0 })
      var training_intents = response.training

      // csvContent += 'Message'

      // csvContent += '\r\n'
      var json = []
      $.each(training_intents, function(index, val) {
        let row = ''

        // row +=
        //   '"' +
        //   (val.questiondata ? val.questiondata : '').replace(/\r?\n|\r/g, ' / ') +
        //   (val.count > 0 ? '(' + val.count + ')' : '') +
        //   '",'

        // csvContent += row + '\r\n'
        json.push({
          message: (val.questiondata ? val.questiondata : '').replace(/\r?\n|\r/g, ' / '),
          count: val.count > 0 ? val.count : 0
        })
      })

      // vm.exportCsv(csvContent, 'training')
      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'training.xlsx')
      vm.loading = false
    }
  },
  watch: {
    allSelected: function(newVal, oldVal) {
      var vm = this
      vm.selectAll()
    }
  }
}
</script>

<style lang="scss" scoped>
.color-black {
  color: rgb(0, 0, 0);
}
.primaryButton {
  margin-left: 0;
  margin-right: 0;
}
.intentmax {
  font-size: 22px;
}
.input-icons {
  display: contents;
  i {
    position: absolute;
  }
  .icon-close {
    color: gray;
    padding: 16px;
    margin-left: -40px;
  }
  .icon {
    padding: 16px;
    min-width: 50px;
  }
  input {
    padding-left: 35px !important;
    padding-right: 35px !important;
    width: 100%;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/Training.vue